import React, { useState } from "react";
import AboutHero from "./components/AboutHero";
import AboutInfoAdmin from "./components/AboutInfoAdmin";
import FamilyLegacyAdmin from "./components/FamilyLegacyAdmin";
import FacilitiesAdmin from "./components/FacilitiesAdmin";
import AmenitiesAdmin from "./components/AmenitiesAdmin";
import AboutVideoAdmin from "./components/AboutVideoAdmin";



const About = () => {
  // Define tabs for the Flavours admin panel
  const TABS = {
    hero: "AboutHero",
    info: "AboutInfo",
    legacy: "AboutLegacy",
    facilities: "Facilities",
    ammentiesServices: "AmenitiesServices",
    aboutVideo: "AboutVideo",

  };

  // Default to the Hero tab
  const [activeTab, setActiveTab] = useState(TABS.hero);

  // Function to switch tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="p-4 space-y-8">
      {/* Top Buttons */}
      <div className="flex flex-wrap gap-4 mb-6">
        <button
          onClick={() => handleTabChange(TABS.hero)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.hero
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          About Hero
        </button> 
        <button
          onClick={() => handleTabChange(TABS.info)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.info
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          About Info
        </button>  
        <button
          onClick={() => handleTabChange(TABS.legacy)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.legacy
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Family Legacy
        </button>
        <button
          onClick={() => handleTabChange(TABS.facilities)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.facilities
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Facilities
        </button>
        <button
          onClick={() => handleTabChange(TABS.ammentiesServices)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.ammentiesServices
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          Amenities Services
        </button>
        <button
          onClick={() => handleTabChange(TABS.aboutVideo)}
          className={`px-6 py-2 rounded ${
            activeTab === TABS.aboutVideo
              ? "bg-blue-600 text-white"
              : "bg-gray-200 text-gray-700"
          }`}
        >
          About Video
        </button>
      </div>

      {/* Render selected component */}
      <div className="bg-gray-50 p-4 rounded shadow">
        {activeTab === TABS.hero && <AboutHero />}
        {activeTab === TABS.info && <AboutInfoAdmin />}
        {activeTab === TABS.legacy && <FamilyLegacyAdmin />}
        {activeTab === TABS.facilities && <FacilitiesAdmin />}
        {activeTab === TABS.ammentiesServices && <AmenitiesAdmin />}
        {activeTab === TABS.aboutVideo && <AboutVideoAdmin />}
      </div>
    </div>
  );
};

export default About;